import { enumerateDaysInPeriod, Period, PeriodType } from '../Models';
import { AnalysisStatus, Emotion } from '../../../Models';
import { EmotionsAndTopicsReport } from './EmotionStatsLogic';
import { groupedByMonthsReport, MoodReport } from './MoodStatsLogic';
import { SingleValueReport, StatsReport } from './Reports';

export const buildFakeInsightsReport = (period: Period): StatsReport => {
  return {
    period,
    moodReports: getFakeMoodsReport(period),
    emotionsReport: getFakeEmotionsReport(),
    avgTimeReport: getFakeAvgWritingTimeReport(),
    pagesReport: getFakePagesCountReport(),
    timeReport: getFakeTotalTimeReport(),
    wordsReport: getFakeWordsReport(),
  };
};

const getFakeAvgWritingTimeReport = (): SingleValueReport => {
  return {
    total: 23,
    diff: 50,
  };
};

const getFakeTotalTimeReport = (): SingleValueReport => {
  return {
    total: 300,
    diff: -10,
  };
};

const getFakePagesCountReport = (): SingleValueReport => {
  return {
    total: 27,
    diff: 43,
  };
};

const getFakeMoodsReport = (period: Period) => {
  const moodReport: MoodReport[] = [];

  enumerateDaysInPeriod(period, (date: Date) => {
    const report = {
      date,
      moodValue: Math.random() * 2 - 1,
      status: AnalysisStatus.analyzed,
    };

    moodReport.push(report);
  });

  if (period.type === PeriodType.YEAR) {
    return groupedByMonthsReport(moodReport);
  }

  return moodReport;
};

const getFakeEmotionsReport = (): EmotionsAndTopicsReport => {
  const emotions = [
    {
      relevance: 0.1,
      category: Emotion.joy,
      subcategory: 'optimism',
      context: null,
      mixedEmotion: null,
    },
  ];

  const topics = [
    {
      relevance: 0.2,
      name: 'Music',
    },
    {
      relevance: 0.3,
      name: 'Home',
    },
    {
      relevance: 0.1,
      name: 'Nuts',
    },
  ];

  return {
    emotions,
    topics,
    failedStatuses: [],
  };
};

const getFakeWordsReport = (): SingleValueReport => {
  return {
    total: 1209,
    diff: 68,
  };
};



// WEBPACK FOOTER //
// ./src/containers/Stats/Logic/FakeReports.tsx